import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Rating, Box, Typography, TextField
} from "@mui/material";
import { useAuth } from "../context/AuthContext";
import api from "../services/api";
import { useTranslation } from "react-i18next";

const STATS_CATEGORIES = [
  { key: "usability", labelKey: "rating_usability" },
  { key: "taste", labelKey: "rating_taste" },
  { key: "speed", labelKey: "rating_speed" },
  { key: "appearance", labelKey: "rating_appearance" },
  { key: "overall", labelKey: "rating_overall" },
];

export default function AppReviewModal({ open, onClose, onSubmitted }) {
  const { t } = useTranslation();  
  const { isLoggedIn } = useAuth();
  const [stars, setStars] = useState(0);
  const [comment, setComment] = useState("");
  const [ratings, setRatings] = useState({
    usability: 0, taste: 0, speed: 0, appearance: 0, overall: 0
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const payload = {
        rating: stars,
        usability: ratings.usability,
        taste: ratings.taste,
        speed: ratings.speed,
        appearance: ratings.appearance,
        overall: ratings.overall,
      };
      if (isLoggedIn && comment) payload.text = comment;

      await api.appReviews.add(payload);

      if (onSubmitted) onSubmitted();
      onClose();
    } catch (e) {
      console.error("Submission error:", e);
    }
    setSubmitting(false);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t("rate_our_app")}</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography sx={{ mb: 1 }}>{t("overall_rating")}</Typography>
          <Rating value={stars} onChange={(_, v) => setStars(v)} />
        </Box>
        {STATS_CATEGORIES.map(item => (
          <Box key={item.key} sx={{ mb: 1 }}>
            <Typography>{t(item.labelKey)}</Typography>
            <Rating
              value={ratings[item.key]}
              onChange={(_, v) =>
                setRatings(prev => ({ ...prev, [item.key]: v }))
              }
            />
          </Box>
        ))}
        {isLoggedIn && (
          <TextField
            label={t("comment_optional") || "Σχόλιο (προαιρετικό)"}
            fullWidth
            multiline
            rows={2}
            value={comment}
            onChange={e => setComment(e.target.value)}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("cancel") || "Άκυρο"}</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={!stars || submitting}>
          {t("submit") || "Υποβολή"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
